export const ORIGINAL_INDEX = 'ORIGINAL_INDEX'      //设置一些常量给mutations当方法名
export const CATE_LIST = 'CATE_LIST'   // 原创达人榜顶部分页
export const ACTIVITY_LIST = 'ACTIVITY_LIST'   // 活动详情



// WEBPACK FOOTER //
// ./src/store/mutations-type.js